import axios from 'axios';
import tokenStorage from './tokenStorage';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { logout } from './actions/userActions';

const baseUrl = process.env.REACT_APP_AUTH_API_URL;
const TOKEN_URL = `${baseUrl}/connect/microsoft/token`;

export default {
	setupInterceptors: (dispatch, history) => {
		// Add auth headers when calling api
		axios.interceptors.request.use((request) => {
			const token = tokenStorage.loadToken();
			if (token && request.url?.includes(baseUrl)) {
				request.headers.Authorization = `Bearer ${token.id_token}`;
			}
			return request;
		});

		// Instantiate the interceptor.
		createAuthRefreshInterceptor(axios, async (failedRequest) => {
			try {
				console.log('request failed', failedRequest, axios);
				const token = tokenStorage.loadToken();
				if (token) {
					const { data } = await axios.post(TOKEN_URL, tokenStorage.loadToken(), {
						skipAuthRefresh: true,
					});
					tokenStorage.saveToken(data);
					failedRequest.response.config.headers.Authorization = `Bearer ${token.id_token}`;
				} else {
					throw new Error('Not logged in');
				}
			} catch (error) {
				console.log('token refresh failed,logout user', error);
				tokenStorage.clearToken();
				dispatch(logout(null));
				history.push('/');
			}
		});
	},
};
